import { APPS } from "./AppsConstants.ts";

export const pagesSort = [APPS.IMAGE_TO_IMAGE, APPS.IMAGE_TO_IMAGE, APPS.TEXT_TO_VECTOR, "campaign", APPS.AUTOMOTIVE];
